<template>
  <div class="bbp-table">
    <div class="bbp-table-row bbp-table-row_header"
         :class="{
           'bbp-table-row_header_hide-border': hoverIndex === 0,
           'bbp-table-row_header-loader': loaderRun
         }"
         v-if="columns && columns.length > 0"
         :style="columnsGrid">
      <div class="bbp-table-row-cell bbp-table-row-cell_header"
           :class="{
             'bbp-table-row-cell_pointer': column.pointer,
             'bbp-table-row-cell_center': column.center,
             'bbp-table-row-cell_active-filter': column.activeFilter,
           }"
           @click="clickHeader(column)"
           v-for="column in columns"
           v-if="!column.hideHead && !column.hideHeaderAccordion"
           :key="column.id"
           :id="column.id"
      >
        <div
          v-if="column.isCalendarFilter"
          class="bbp-table-row-cell-filter-calendar"
          @click.stop
        >
          <BBPDatePicker
            :key="resetFilterCalendar"
            :input="column.calendarFilterSettings"
            :model="column"
            styleType="only-icon"
            @input="onChangeDate"
          />
        </div>
        <div
          v-if="column.isCalendarFilter && column[column.prop]"
          class="bbp-table-row-cell-filter-calendar-content"
        >
          {{filterCalendar}}
          <i
            class="bbp-icon-cross"
            @click.stop="onClosePopup(column)"
          />
        </div>
        <span>{{ column.title }}</span>
        <span
          v-if="column.iconTitle"
          v-html="column.iconTitle()"
          :style="column.iconStyle"
        />
        <i
          v-if="column.sortBy"
          class="bbp-icon-arrow-top bbp-table-row-cell__icon-sort"
           :class="{
             'bbp-table-row-cell__icon-sort_active': sortBy === column.sortBy
           }"
        />
        <div
          v-if="column.filterBy"
          class="bbp-table-row-cell__filter"
          v-html="filterIcon()"
        />
        <BBPFilterPopup
          v-if="filterOpen === column.id"
          :key="resetFilter"
          :column="column"
          @onChangeFilter="onChangeFilter"
        />
      </div>
    </div>
    <VuePerfectScrollbar
      v-if="!loaderRun"
      class="bbp-table-body"
      ref="bbpScrollContainer"
      :style="{maxHeight: maxHeight}"
    >
      <div class="bbp-table-row"
           :class="{
           'bbp-table-row_hide-border': hoverIndex === index + 1,
           'bbp-table-row_active': hoverRow === row.id,
           'bbp-table-row_disabled': row.disabled
         }"
           @mouseleave="setHover('', false)"
           @mouseenter="setHover(row.id, index)"
           :style="columnsGrid"
           v-for="(row, index) in rows"
           :key="row.id">
        <div
          v-if="!column.hideHead"
          v-for="column in columns"
          class="bbp-table-row-cell"
          :class="{'bbp-table-row-cell_center': column.center}"
          :key="column.id"
          :style="column.style || {}"
        >
          <component :is="getComponentByType(column)"
                     :row="row"
                     :rows="rows"
                     :column="column"
                     :hover="hoverRow"
                     :index="getIndexWithPage(index)"
                     @onResetFilter="onResetFilter"
                     @filter="setFilter"
                     @update="updateItem"
                     @updateProject="updateProject"
                     @delete="deleteItem"
                     @copy="copyItem"
                     @edit="editItem"/>
        </div>
      </div>
    </VuePerfectScrollbar>
    <BBPTableNoData :description="noDataText" v-if="noData && (!rows || rows.length === 0)"/>
  </div>
</template>

<script>
import {get, filter} from 'lodash'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import BBPTableNoData from '@/components/Main/BBPTable/BBPTableNoData/BBPTableNoData'
import BBPDateCell from '@/components/Main/BBPTable/BBPDateCell/BBPDateCell'
import BBPStringCell from '@/components/Main/BBPTable/BBPStringCell/BBPStringCell'
import BBPNumberCell from '@/components/Main/BBPTable/BBPNumberCell/BBPNumberCell'
import BBPIndexCell from '@/components/Main/BBPTable/BBPIndexCell/BBPIndexCell'
import BBPImageCell from '@/components/Main/BBPTable/BBPImageCell/BBPImageCell'
import BBPLargeTextCell from '@/components/Main/BBPTable/BBPLargeTextCell/BBPLargeTextCell'
import BBPToolbarTable from '@/components/Main/BBPTable/BBPToolbarTable/BBPToolbarTable'
import BBPAccordionCell from '@/components/Main/BBPTable/BBPAccordionCell/BBPAccordionCell'
import BBPSelectCell from '@/components/Main/BBPTable/BBPSelectCell/BBPSelectCell'
import BBPAccordionContentCell from '@/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCell'
import BBPCreateInvoice from '@/components/Main/BBPTable/BBPCreateInvoice/BBPCreateInvoice'
import BBPCompleteProject from '@/components/Main/BBPTable/BBPCompleteProject/BBPCompleteProject'
import BBPToolbarMenu from '@/components/Main/BBPTable/BBPToolbarMenu/BBPToolbarMenu'
import BBPFileCell from '@/components/Main/BBPTable/BBPFileCell/BBPFileCell'
import BBPTagCell from '@/components/Main/BBPTable/BBPTagCell/BBPTagCell'
import BBPTimer from '@/components/Main/BBPTable/BBPTimer/BBPTimer'
import BBPDateChoose from '@/components/Main/BBPTable/BBPDateChoose/BBPDateChoose'
import BBPAddUserSelect from '@/components/Main/BBPTable/BBPAddUserSelect/BBPAddUserSelect'
import BBPStringCellEdit from '@/components/Main/BBPTable/BBPStringCellEdit/BBPStringCellEdit'
import BBPReminder from '@/components/Main/BBPTable/BBPReminder/BBPReminder'
import {FILTER_ICON} from '@/constants/icons'
import BBPFilterPopup from '@/components/Main/BBPTable/BBPFilterPopup/BBPFilterPopup'
import BBPPercentComplete from '@/components/Main/BBPTable/BBPPercentComplete/BBPPercentComplete'
import BBPDatePicker from '@/components/Main/BBPForm/BBPDatePicker/BBPDatePicker'
import BBPMark from '@/components/Main/BBPTable/BBPMark/BBPMark'

export default {
  name: 'BBPTable',
  components: {
    BBPPercentComplete,
    BBPFilterPopup,
    BBPToolbarMenu,
    BBPImageCell,
    BBPIndexCell,
    BBPNumberCell,
    BBPStringCell,
    BBPDateCell,
    BBPTableNoData,
    BBPAccordionCell,
    BBPAccordionContentCell,
    BBPSelectCell,
    BBPCreateInvoice,
    BBPCompleteProject,
    BBPFileCell,
    BBPTagCell,
    BBPAddUserSelect,
    VuePerfectScrollbar,
    BBPDatePicker
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    noData: {
      type: Boolean,
      default: false
    },
    loaderRun: {
      type: Boolean,
      default: false
    },
    noDataText: {
      type: String,
      default: 'Sorry, no reports found.'
    },
    maxHeight: {
      type: String,
      default: 'auto'
    },
    limit: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    resetFilter: {
      type: Number,
      default: 0
    },
    resetFilterCalendar: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      hoverIndex: false,
      hoverRow: '',
      filterOpen: false,
      sortBy: '',
      filterIcon: FILTER_ICON,
      filterCalendar: ''
    }
  },
  computed: {
    columnsGrid () {
      const columns = filter(this.columns || [])
      const repeat = columns.map(item => item.width || 'minmax(70px, 1fr)').join(' ')
      return {
        gridTemplateColumns: `${repeat}`
      }
    }
  },
  methods: {
    onChangeFilter (column, item) {
      const { options = [] } = column
      const { _id } = item
      options.forEach((el) => {
        el.isActive = false
      })
      const currentItem = options.find((el) => el._id === _id)
      if (currentItem) currentItem.isActive = true
      this.$emit('onChangeFilter', column, item)
    },
    clickHeader (column) {
      const { sortBy, filterBy, id } = column
      if (sortBy) {
        const revert = '&sort[]=-1'
        this.sortBy = this.sortBy === column.sortBy ? column.sortBy + revert : column.sortBy
        this.$emit('sort', this.sortBy)
      }

      if (filterBy) {
        this.filterOpen = id
      }
    },
    onClosePopup (column) {
      const { prop } = column
      this.filterCalendar = ''
      this.$set(column, [prop], '')
      this.$emit('onChangeFilter', column, {})
      column.activeFilter = false
    },
    onChangeDate (data, model, input) {
      if (!data) return
      const { end, start } = data
      const { format } = input
      model[input.model] = data
      this.filterCalendar = `${moment(start).format(format)} - ${moment(end).format(format)}`
      model.activeFilter = true
      this.$emit('onChangeFilter', model, {})
    },
    getIndexWithPage (index) {
      return this.page === 1 ? index : index + ((this.page - 1) * this.limit)
    },
    deleteItem (currentRow) {
      this.$emit('delete', currentRow)
    },
    editItem (currentRow) {
      this.$emit('edit', currentRow)
    },
    copyItem (currentRow) {
      this.$emit('copy', currentRow)
    },
    updateItem ({row, column, value}) {
      this.$emit('update', {row, column, value})
    },
    updateProject (currentElem) {
      this.$emit('updateProject', currentElem)
    },
    setFilter ({row, column, newVal}) {
      const prop = get(column, 'prop', '')
      const value = get(row, prop, '')
      this.$emit('filter', {row, column, value, prop, newVal})
    },
    setHover (rowId, index) {
      this.hoverRow = rowId
      this.hoverIndex = index
    },
    onResetFilter () {
      this.$emit('onResetFilter')
    },
    getComponentByType (column) {
      const type = get(column, 'type', '')
      switch (type) {
      case 'image':
        return BBPImageCell
      case 'number':
        return BBPNumberCell
      case 'date':
        return BBPDateCell
      case 'index':
        return BBPIndexCell
      case 'toolbar':
        return BBPToolbarTable
      case 'accordion':
        return BBPAccordionCell
      case 'accordionContent':
        return BBPAccordionContentCell
      case 'select':
        return BBPSelectCell
      case 'largeText':
        return BBPLargeTextCell
      case 'createInvoice':
        return BBPCreateInvoice
      case 'completeProject':
        return BBPCompleteProject
      case 'menu':
        return BBPToolbarMenu
      case 'file':
        return BBPFileCell
      case 'tag':
        return BBPTagCell
      case 'timer':
        return BBPTimer
      case 'dateChoose':
        return BBPDateChoose
      case 'addUserSelect':
        return BBPAddUserSelect
      case 'stringCellEdit':
        return BBPStringCellEdit
      case 'reminder':
        return BBPReminder
      case 'percentComplete':
        return BBPPercentComplete
      case 'mark':
        return BBPMark
      default:
        return BBPStringCell
      }
    },
    scrollReset () {
      const container = get(this.$refs, 'bbpScrollContainer.$el', '')
      if (container) {
        container.scrollTop = 0
        container.scrollLeft = 0
      }
    }
  },
  watch: {
    rows () {
      this.scrollReset()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbp-table {
  @include global-font;
  display: inline-grid;
  min-width: 100%;
  background: $color-white;
  box-shadow: 0 0 20px rgba($color-black, 0.05);
  border-radius: 5px;
  min-height: 104px;

  &-body {
    padding: 12px 4px 9px;
    margin: -12px -4px 0;
    box-sizing: border-box;
  }

  &-row {
    position: relative;
    display: grid;
    align-items: center;
    width: 100%;
    height: auto;
    min-height: 52px;
    grid-gap: 0 10px;
    font-size: 13px;
    padding: 8px 35px;
    transition: 0.3s;

    &:hover:not(&_header) {
      box-shadow: 0 0 12px rgba($color-black, 0.15);
      border-radius: 0 5px 5px 0;
      border-top-color: transparent;
      z-index: 4;

      &:before {
        opacity: 1;
      }
    }

    &:before {
      content: '';
      position: absolute;
      top: -1px;
      left: -4px;
      width: 4px;
      opacity: 0;
      height: calc(100% + 2px);
      background-color: $color-accent;
      border-radius: 4px 0 0 4px;
      transition: 0.3s;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 35px;
      height: 1px;
      width: calc(100% - 70px);
      background-color: $color-wild-sand;
    }

    &:last-child {
      &:after {
        content: none;
      }
    }

    &_header {
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: $color-accent;
      z-index: 3 !important;
      background-color: $color-white;
      cursor: default;

      &_hide-border {
        &:after {
          background-color: transparent;
        }
      }
    }

    &_header-loader {
      max-height: 52px;
    }

    &_disabled {
      color: $color-silver;
    }

    &_active, &_hide-border {
      &:after {
        background-color: transparent;
      }
    }

    &-cell {
      user-select: none;
      position: relative;

      &_header {
        display: flex;
        align-items: center;
      }

      &_center {
        justify-content: center;
        margin: 0 auto;
      }

      &_active-filter {
        color: $color-japanese-laurel;
      }

      &_pointer {
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          color: $color-accent-hover;
        }
      }

      &__icon-sort {
        margin-left: 5px;
        font-size: 8px;
        transition: 0.2s linear;

        &_active {
          transform: rotate(180deg);
        }
      }

      &__filter {
        margin: 0 0 0 8px;
        cursor: pointer;
        transition: 0.2s;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}

.bbp-table-row-cell-filter-calendar {

  &-content {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    line-height: 13px;
    font-weight: 400;
    color: $color-gray;
    white-space: nowrap;
  }
}

</style>

<style lang="scss">
@import "../../../sass/variables";

  .bbp-table-row-cell-filter-calendar {
    .bbp-date-picker-body__date {
      display: none;
    }

    .bbp-date-picker-body_only-icon {
      padding: 5px 5px 5px 0 !important;
    }

    .bbp-icon-calendar {
      display: flex;
      font-size: 10px;
    }

    .bbp-date-picker-body-range {
      display: none !important;
    }
   }

  .bbp-table-row-cell_active-filter {
    .bbp-icon-calendar {
      color: $color-japanese-laurel !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTable.vue